module.exports = __webpack_public_path__ + "static/media/hiw_3.4f021cdb.svg";